import { IBBox } from '../types/map/bbox';

export function convertBboxToString(bbox: IBBox) {
  const { bottomRight, topLeft } = bbox;

  return `${bottomRight.lat},${topLeft.lng},${topLeft.lat},${bottomRight.lng}`;
}
